module.exports = "/_next/static/images/doge-3e06c4066b11eaefbae5b88109301f4c.png";